import api from './api';

export const newUploadId = () => `u${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;

/** Ask the server to stop before closing the original request. */
export const requestUploadCancellation = (uploadId) => api.post(`/uploads/${uploadId}/cancel`);
